import { CartItemFragment } from '@src/queries/CartQuery.generated'
import { Pricing } from './TrackedAvailabilityMessageContext'
import { MaterialAvailability } from '@src/types/graphql-types'
import { FormattedMessageProps } from 'react-intl'

export type Availability = Pick<
  MaterialAvailability,
  | 'plantLoc'
  | 'date'
  | 'quantity'
  | 'availabilityOverwriteMessage'
  | 'supplementaryMessage'
>

export type TrackedAvailabilityMessageProps = FormattedMessageProps & {
  availability?: Availability
}

export const getCartItemPricing = (cartItem: CartItemFragment): Pricing => ({
  ...cartItem.pricing,
  currency: cartItem.currency,
  listPriceCurrency: cartItem.listPriceCurrency,
  promotionalMessage: cartItem.promotionalMessage,
  supplementaryMessage: cartItem.supplementaryMessage,
  availabilityOverwriteMessage: cartItem.availabilityOverwriteMessage,
})
